import { render, staticRenderFns } from "./LandingComoCards.vue?vue&type=template&id=e2edd7be"
import script from "./LandingComoCards.vue?vue&type=script&lang=js"
export * from "./LandingComoCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports